// extracted by mini-css-extract-plugin
export default {"confirmationBody":"ConfirmationBody_confirmationBody__bGwJw","buttons":"ConfirmationBody_buttons__Cz0i7"};